<template>
  <div class="menu-page">
    <div class="menu-page-left">
      <template>
        <a-tree
          :tree-data="treeData"
          @select="onSelect"
          :selectedKeys.sync="selectedKeys"
        />
      </template>
    </div>
    <div class="menu-page-right">
      <div class="menu-page-view">
        <component :is="componentName" :code="activeKey" :title="title" />
      </div>
    </div>
  </div>
</template>

<script>
import pages from "./restaurant/";

export default {
  name: "MaintenanceRestaurant",
  components: {
    ...pages
  },
  data() {
    return {
      treeData: [
        {
          title: "桌台管理",
          key: "RestTable"
        },
        {
          title: "菜品分类",
          key: "FoodCategory"
        },
        {
          title: "菜品管理",
          key: "Food"
        },
        {
          title: "做法",
          key: "CookingMethod"
        },
        {
          title: "单位",
          key: "Unit"
        },
        {
          title: "客源",
          key: "ResGuestSource"
        },
        {
          title: "打印机",
          key: "Printer"
        },
        {
          title: "消息设置",
          key: "ConfirmSetting"
        },
        {
          title: "分市",
          key: "RestaurantMarket"
        },
        {
          title: "餐厅相簿",
          key: "RestaurantPhoto"
        }
      ],
      selectedKeys: ["RestTable"],
      activeKey: "RestTable",
      title: ""
    };
  },
  created() {},
  computed: {
    componentName() {
      if (pages[this.activeKey]) {
        return pages[this.activeKey];
      }
      return "Base";
    }
  },
  methods: {
    onSelect(key) {
      if (key && key.length) {
        this.activeKey = key[0];
        this.title = this.treeData.find(el => el.key == this.activeKey).title;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu-page {
  width: 100%;
  display: flex;
  height: calc(100vh - 130px);
  overflow: auto;

  &.mobile {
    display: block;

    .menu-page-left {
      border-right: unset;
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      height: 50px;
      overflow-x: auto;
      overflow-y: scroll;
    }
    .menu-page-right {
      padding: 20px 40px;
    }
  }

  .menu-page-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;
    height: calc(100vh - 130px);
    // overflow: hidden;
    // overflow-y: auto;
  }

  .menu-page-right {
    flex: 1 1;
    padding: 0 40px;
    width: 100%;
    overflow: hidden;
    height: calc(100vh - 130px);
    overflow-y: auto;
    .menu-page-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .menu-page-view {
      padding-top: 12px;
    }
  }
}
</style>
